import Modal from './Modal';
import Button from './Button';

/**
 * Thin wrapper around Modal for a "are you sure?" gate in front of a
 * destructive action. No confirm-before-destroy primitive existed in the
 * app before this — deleting/revoking an administrator account is the
 * first action serious enough to warrant one.
 */
export default function ConfirmDialog({
  open,
  onClose,
  onConfirm,
  title = 'Are you sure?',
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  tone = 'danger',
  isLoading,
}) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title={title}
      footer={
        <>
          <Button type="button" variant="secondary" onClick={onClose} disabled={isLoading}>
            {cancelLabel}
          </Button>
          <Button type="button" variant={tone} onClick={onConfirm} isLoading={isLoading}>
            {confirmLabel}
          </Button>
        </>
      }
    >
      <p className="text-sm text-foreground-muted">{message}</p>
    </Modal>
  );
}
